export default __webpack_public_path__ + "static/19-c841c627edaa2500ed8c76fa07508387.png";